/* Pending approval count for the shell badge. Kept apart from the screen so the feature descriptor can
   read it without loading the screen's code. Updated by `usePendingApprovals` (ApprovalInbox.tsx). */
import { create } from 'zustand';

export const useApprovalCount = create<{ count: number; set: (n: number) => void }>((set) => ({ count: 0, set: (count) => set({ count }) }));
